import React, { useState } from "react";
import "./SellersWin.scss";
import { Row, Col, Button, Carousel, Layout } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import Slider from "react-slick"
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
const { Content } = Layout;

const carouselData = [
    {
        'img': '/smb/car_1.png',
        'title': 'NIDRA enhances Amazon listings with ALL3D’s immersive 3D technology',
        'desc': 'NIDRA partnered with ALL3D to quickly create immersive 3D models and color variants for its sleep masks, elevating its presence on Amazon. The easy-to-use platform allowed NIDRA to produce high-quality visuals in just 24 hours, enhancing customer engagement and showcasing product quality in a cost-effective way.',
        'key_wins': [
            {
                'icon': '/smb/lightning-light.png',
                'desc': '3D models were live on Amazon within 24 hours'
            },
            {
                'icon': '/smb/pig-light.png',
                'desc': 'Delivered high-quality visuals at a fraction of traditional costs'
            }
        ],
        'logo': '/smb/nidra_logo.png',
        'link': 'https://www.amazon.com/stores/Nidra/Nidra/page/3CC491F9-8283-4AE3-BFA6-DA6649A67ECA'
    },
    {
        'img': '/smb/car_2.png',
        'title': 'Homestyles elevates furniture shopping with ALL3D’s immersive 3D technology',
        'desc': "Homestyles partnered with ALL3D to enhance its Amazon presence. Redefining convenience and style in home furnishings, Homestyles uses ALL3D’s platform to create photorealistic product images, lifestyle scenes, and AR view in room experiences, cutting traditional photography costs and improving the shopping journey.",
        'key_wins': [
            {
                'icon': '/smb/point.svg',
                'desc': 'Design teams generate high-quality product and lifestyle imagery in a few clicks'
            },
            {
                'icon': '/smb/mynaui_ar.svg',
                'desc': 'Enabled AR view in room experiences for Amazon shoppers'
            }
        ],
        'logo': '/smb/homestyles.png',
        'link': 'https://www.amazon.com/stores/page/EC6F7B55-2BD4-42FF-B4EE-69C057719D93/'
    },
    {
        'img': '/smb/car_3.png',
        'title': 'Headlights Depot put their Amazon product detail pages in the spotlight',
        'desc': "Thanks to ALL3D’s easy-to-use platform, Headlights Depot put the high beams on their product visuals, generating stunning, photorealistic 3D models for use on their own website and on Amazon. Just like a high-performance headlight cuts through the dark, ALL3D’s technology brightens the path for better engagement and increased sales.",
        'key_wins': [
            {
                'icon': '/smb/lightning-light.png',
                'desc': '3D models created and live on Amazon faster than a quick lane change'
            }
        ],
        'logo': '/smb/headlights.png',
        'link': 'https://www.amazon.com/stores/page/0C080719-B269-4D34-B670-99B3A4345BBA'
    }
]

const SellersWin = () => {

    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    );
}

const WebVersion = () => {

    let carousel = React.createRef();


    const next = () => {
        if (carousel) {
            carousel.next();
        }
    };

    const prev = () => {
        if (carousel) {
            carousel.prev();
        }
    };


    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid justify-in-center sellers-win-bg">
                <Col span={24} className="justify-in-center text-center mb-56">
                    <h1 className="manrope f-38 lh-46 w-600 white">See how sellers win with ALL3D</h1>
                </Col>

                <Col span={2} className="direction-flex justify-in-start">
                    <Button onClick={prev}
                        icon={<ArrowLeftOutlined className="manrope f-20 lh-0" />}
                        className="carousel-btn-ar"
                    />
                </Col>

                <Col span={18}>
                    <div className="seller-win">
                        <Carousel
                            dots={true}
                            autoplay={false}
                            ref={(node) => carousel = node}
                            style={{ width: "100%" }}>
                            {carouselData.map((data, index) => (
                                <Row className="win-slide-bg">
                                    <Col span={12}>
                                        <img src={data.img} className="seller-img" />
                                    </Col>
                                    <Col span={12} className="carousel-text-col">
                                        <div>
                                            <div>
                                                <h3 className="manrope f-20 black-085 w-700 lh-28 text-left">{data.title}</h3>
                                                <p className="manrope f-14 w-500 black-085 lh-22 text-left mb-24">{data.desc}</p>
                                            </div>
                                            <div className="j-sb-a-start gap-16-seller">
                                                {data.key_wins.map((win, index) => (
                                                    <Col span={data.key_wins.length == 1 ? 24 : 11} className="j-start-a-start direction-flex">
                                                        <img src={win.icon} />
                                                        <p className="manrope f-14 lh-22 black-085 w-500 text-left ml-8 mb-0">{win.desc}</p>
                                                    </Col>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="justify-space-between">
                                            <Col span={12}>
                                                <img src={data.logo} />
                                            </Col>
                                            <Col span={12} className="justify-in-end direction-flex">
                                                <div onClick={() => {
                                                    window.open(data.link, "_blank")
                                                }} className="manrope f-14 w-500 blue  cursor pointer justify-in-end text-left">View this seller on Amazon <ArrowRightOutlined className="ml-8" /></div>
                                            </Col>
                                        </div>
                                    </Col>

                                </Row>
                            ))}
                        </Carousel>
                    </div>
                </Col>
                <Col span={2} className="direction-flex justify-in-end">
                    <Button onClick={next}
                        icon={<ArrowRightOutlined className="manrope f-20 lh-0" />}
                        className="carousel-btn-ar"
                    />
                </Col>
            </Row>
        </Content>
    );
}

const MobileVersion = () => {
    const [isExpanded, setIsExpanded] = useState(false);

    const settings = {
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1.07,
        slidesToScroll: 1,
        vertical: false,
        customPaging: i => (
            <div className="custom-dot">
                {/* &ndash;  This is the dash */}
            </div>
        ),
    };

    return (
        <Content className="d-lg-none">
            <Row className="container-fluid justify-in-center sellers-win-bg">
                <Col span={24} className="justify-in-center text-center mb-32 pdlr-16">
                    <h1 className="manrope f-30 lh-46 w-600 white">See how sellers win with ALL3D</h1>
                </Col>

                <Col span={24} className="pdl-16">
                    <Slider {...settings} className="wins-card">
                        {carouselData.map((data, index) => (
                            <Row className={`win-slide-bg ${index == 0 ? `first` : ``}`}>
                                <div className={`box ${isExpanded ? 'expanded': ''}`}>
                                    <div className="img-setting-col">
                                        <img src={data.img} className="seller-img mb-24" />
                                    </div>
                                    <div className="pdlr-16">
                                        <div>
                                            <h3 className="manrope f-20 black-085 w-700 lh-28 text-left mb-8">{data.title}</h3>
                                            {isExpanded ?
                                                <p className="manrope f-16 w-500 black-085 lh-24 text-left">
                                                    {data.desc}
                                                </p> : ''}
                                            <p onClick={() => setIsExpanded(!isExpanded)}
                                                className="manrope f-16 w-500 blue lh-24 text-left mb-24">
                                                {isExpanded ? 'Read Less' : 'Read More'}
                                            </p>

                                        </div>
                                        <div className="j-sb-a-start direction-flex mb-32">
                                            {data.key_wins.map((win, index) => (
                                                <Col span={data.key_wins.length == 1 ? 24 : 12}>
                                                    <img src={win.icon} className="mb-8" />
                                                    <p className="manrope f-14 lh-22 black-085 w-500 text-left ml-8">{win.desc}</p>
                                                </Col>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="pdlr-16">
                                        <img src={data.logo} className="mb-16" />
                                        <div onClick={() => {
                                            window.location.href = data.link
                                        }} className="manrope f-14 w-500 blue cursor pointer justify-space-between">
                                            View this seller on Amazon <ArrowRightOutlined className="ml-8" />
                                        </div>

                                    </div>
                                </div>
                            </Row>
                        ))}
                    </Slider>
                </Col>

            </Row>
        </Content>
    );
}


export default SellersWin;
